import { SpoGendersResponseItem, SpoSportsResponse } from '@spo/types';
import { useQueryClient } from '@tanstack/react-query';
import { VpButton } from '@vtmn-play/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../../contexts/ToastContext';
import { usePatchSportSettings } from '../../../hooks/mutations/usePatchSportSettings';
import { GenderCheckboxes } from '../genderCheckboxes';
import './archi-header-settings.scss';

export interface ArchiHeaderNewSettingsProps {
  isSportDataLoading: boolean;
  sportData: SpoSportsResponse;
  allGenders: SpoGendersResponseItem[];
  sportId: number;
}

export const ArchiHeaderNewSettings = ({
  isSportDataLoading,
  sportData,
  allGenders,
  sportId,
}: ArchiHeaderNewSettingsProps) => {
  const [selectedGenderIds, setSelectedGenderIds] = useState<number[]>([]);

  const { t } = useTranslation();
  const { addToast } = useToast();

  const queryClient = useQueryClient();

  const mutationSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: ['useSportsByIds', [sportId]],
    });
    addToast(
      t('architecture.update-sport-settings.success'),
      'success',
      4500,
      'archi-update-sport-settings-success',
    );
  };

  const mutationError = () => {
    addToast(
      t('architecture.update-sport-settings.error'),
      'danger',
      4500,
      'archi-update-sport-settings-error',
    );
  };

  const { mutate: saveNewSettings, isPending } = usePatchSportSettings(
    sportId,
    selectedGenderIds,
    mutationSuccess,
    mutationError,
  );

  const isCreationDisabled = selectedGenderIds.length === 0;

  return (
    <div className="architecture-settings-align">
      <div
        className="architecture-settings-container new"
        data-testid="architecture-new-settings-editing-container"
      >
        <div
          className="architecture-settings"
          data-testid="architecture-new-settings"
        >
          {allGenders && (
            <GenderCheckboxes
              chosenGenderIds={sportData[0].configuration?.genders || []}
              allGenders={allGenders}
              selectedGenderIds={selectedGenderIds}
              setSelectedGenderIds={setSelectedGenderIds}
              disabled={false}
            />
          )}
        </div>
      </div>
      <div
        className="archi-settings-buttons"
        data-testid="archi-settings-buttons"
      >
        <VpButton
          data-testid="archi-settings_save-button"
          size="small"
          shape="squared"
          onClick={() => saveNewSettings()}
          loading={isPending || isSportDataLoading}
          disabled={isCreationDisabled}
        >
          {t('create')}
        </VpButton>
      </div>
    </div>
  );
};
